jQuery(function ($) {

    if ( $('#js-btn-incomplete').length && $('#js-btn-incomplete').length ) {

        $('#js-btn-complete').on('click', function(){
            if ( $(this).hasClass('is-inactive') ){
                $(this).removeClass('is-inactive');
                $(this).addClass('is-active');
                $('#js-btn-incomplete').removeClass('is-active');
                $('#js-btn-incomplete').addClass('is-inactive');
                $('.my-program__list.is-incomplete').hide();
                $('.my-program__list.is-incomplete .program__progress-bar').css('width', '2px');
                $('.my-program__list.is-complete').fadeIn();
                if ( $('.my-program__list.is-complete').find('.my-program__none-program').length ) {
                    $('.my-program__body').addClass('is-none-program');
                } else {
                    $('.my-program__body').removeClass('is-none-program');
                }
            }
        });
        $('#js-btn-incomplete').on('click', function(){
            if ( $(this).hasClass('is-inactive') ){
                $(this).removeClass('is-inactive');
                $(this).addClass('is-active');
                $('#js-btn-complete').removeClass('is-active');
                $('#js-btn-complete').addClass('is-inactive');
                $('.my-program__list.is-complete').hide();
                $('.my-program__list.is-complete .program__progress-bar').css('width', '2px');
                $('.my-program__list.is-incomplete').fadeIn();
                if ( $('.my-program__list.is-incomplete').find('.my-program__none-program').length ) {
                    $('.my-program__body').addClass('is-none-program');
                } else {
                    $('.my-program__body').removeClass('is-none-program');
                }
            }
        });
    }
});